import { render, staticRenderFns } from "./real-time-intercom.vue?vue&type=template&id=36c80b30"
import script from "./real-time-intercom.vue?vue&type=script&lang=js"
export * from "./real-time-intercom.vue?vue&type=script&lang=js"
import style0 from "./real-time-intercom.vue?vue&type=style&index=0&id=36c80b30&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports